import React from 'react';
import MeetingSummary from './meeting_summary';
import StaffAvailability from './staff_availability_card';
import StudentCohorts from './student_cohorts';
import Facilities from './facilities';
import Agenda from './agenda';

const InspectorCardList = React.createClass({

  getDefaultProps: function() {
    return {
      cardsById: {
        summary: (card, props) => {
          return <MeetingSummary {...card} onChange={props.onMeetingChange} />
        },
        staff_availability: (card, props) => {
          return <StaffAvailability {...card} />
        },
        students: (card, props) => {
          return <StudentCohorts {...card} onFilterChange={props.onStudentFilterChange} />
        },
        facilities: (card, props) => {
          return <Facilities {...card} />
        },
        agenda: (card, props) => {
          return <Agenda {...card} />
        }
      }
    }
  },

	render: function() {
    let element = this._defaultContent();
    let cards;
    
    if(this.props.render) {
      cards = this._getCardComponents(this.props.items);
      element = (
      	<ul className="abl-inspector-card-list">
          {cards}
        </ul>
      );
    }

    return element;
  },

  _getCardComponents: function(cards) {
    return cards.reduce((components, card) => {
      
      let component = this.props.cardsById[card.id](card, this.props);
      if(!component) {
        throw new Error({message: `Could not find card: ${card.id}`})
      }
      
      components.push((
        <li key={components.length}>
          {component}
        </li>
      ));

      return components;
    }, []);
  },

  _defaultContent: function() {
    return (
      <div className="abl-default-message">
        <h4>Nothing selected.</h4>
        <p>
          Select a time block to see more.
        </p>
      </div>
    );
  }

});

export default InspectorCardList;


/** WEBPACK FOOTER **
 ** ./src/js/components/schedule_inspector/inspector_card_list.js
 **/